import { Chip } from '@heroui/react'
import { formatStatusText, getTenantStatusColor } from '@qse/utils'

interface StatusChipProps {
  status: string
  className?: string
  size?: 'sm' | 'md' | 'lg'
  variant?: 'flat' | 'solid' | 'bordered' | 'light' | 'faded' | 'shadow' | 'dot'
}

/**
 * Reusable status chip component with consistent styling and colors
 */
const StatusChip = ({
  status,
  className = 'capitalize rounded font-medium',
  size = 'sm',
  variant = 'flat',
}: StatusChipProps) => {
  const color = getTenantStatusColor(status)
  const formattedStatus = formatStatusText(status)

  return (
    <Chip className={className} color={color} size={size} variant={variant}>
      {formattedStatus}
    </Chip>
  )
}

export default StatusChip
